import { Box, Typography } from '@mui/material';
import { formatNumberToCurrency } from '@/utils/currency';

interface BalanceSectionHeaderProps {
  title: string;
  amount: number;
  isNegative?: boolean;
  showParentheses?: boolean;
}

export const BalanceSectionHeader = ({
  title,
  amount,
}: BalanceSectionHeaderProps) => {
  const formattedAmount = formatNumberToCurrency(amount);

  return (
    <Box
      // Dark-theme text prints white-on-white; chart-print-safe forces it dark
      // (see index.css). Applies wherever this header is used.
      className='chart-print-safe'
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      mb={2}
      width='100%'
    >
      <Typography variant='h6'>{title}</Typography>
      <Typography variant='h6'>{formattedAmount}</Typography>
    </Box>
  );
};
